// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"2eef5a69","78":"0e9683cb","650":"04350ec2","748":"23a6218f","787":"ee330d5d","900":"9efb9b92","912":"2e106b92","948":"22154050"}[chunkId] + ".chunk.js";
};